import { checkingAccessToTheEntity, checkPermissions } from '@/utils/accesses'

const getters = {
  isExternalSystem: (state) =>
    checkPermissions(state?.userData?.permissions, ['external_system_legacy']),
    getCurrentFiat: (state) => state.userData.preferredCurrency,
    hasEntityAccess: (state) => checkingAccessToTheEntity(state.userData.permissions || []),
    permissions: (state) => state.userData && state.userData.permissions,
    currentUserPermissions: (state) => state.userData && state.userData.permissions || [],
    hasRestrictNegativeFlag: (state) => {
      const { permissions, requestsLeft } = state.userData
      return (
        requestsLeft !== null &&
        requestsLeft <= 0 &&
        checkPermissions(permissions, ['billing_restrict_negative'])
      )
    }
}

export default getters
